import { getDealById } from 'api/deals.api';
import { $detail, $form, $view } from 'signals/global.signals';
import displayError from 'utils/displayError';
import moment from 'moment';
import { getOrgFinancialMetrics } from 'api/metrics.api';
import { getOrgPipelinesOnFounder } from 'api/founderPipeline.api';

export async function fetchAndSetDealData(id) {
  $view.update({
    isLoading: true,
    isTableLoading: true,
  });
  try {
    const [metrics, deal, { data: pipelines }] = await Promise.all([
      getOrgFinancialMetrics(),
      getDealById(id),
      getOrgPipelinesOnFounder(),
    ]);

    const pipelineItemsInDeal = pipelines.filter((pipelineItem) => pipelineItem.dealId === Number(id));
    const investorEmailsInDeals = pipelineItemsInDeal.map((pipelineItem) => pipelineItem.organization.email);
    const pipelineItemsNotInDeal = pipelines.filter((pipelineItem) => !investorEmailsInDeals.includes(pipelineItem.organization.email));

    const sumOfCommitted = pipelineItemsInDeal.reduce((acc, pipelineItem) => acc + pipelineItem.previouslyCommitted, 0);
    const sumOfInvested = pipelineItemsInDeal.reduce((acc, pipelineItem) => acc + pipelineItem.amountInvested, 0);

    const investorOptions = pipelineItemsNotInDeal
      .map((pipelineItem) => ({
        label: pipelineItem.organization.name,
        value: `${pipelineItem.organization.recordType}-${pipelineItem.organization.id}`,
        recordType: pipelineItem.organization.recordType,
      }));

    $view.update({
      investorOptions,
      metrics,
      name: deal.name,
    });
    deal.fundingDate = deal.fundingDate ? deal.fundingDate.split('T')[0] : moment().format('YYYY-MM-DD');
    $detail.update({ ...deal, pipelineItems: pipelineItemsInDeal, sumOfCommitted, sumOfInvested });
    $form.update({
      name: deal.name,
      investmentStage: deal.investmentStage,
      typeOfRaise: deal.typeOfRaise,
      currentValue: deal.currentValue,
      currentRaiseSize: deal.currentRaiseSize,
      amountCommitted: deal.amountCommitted,
      minimumInvestment: deal.minimumInvestment,
      fundingDate: deal.fundingDate.split('T')[0] || moment().format('YYYY-MM-DD'),
      usesOfCapital: deal.usesOfCapital,
      preMoneyValuation: deal.preMoneyValuation,
      amountPreviouslyRaised: deal.amountPreviouslyRaised,
      valuationLastRound: deal.valuationLastRound,
      cap: deal.cap,
      dataVaultInclusion: deal.isIncludeAllDocuments ? 'all' : 'select',
      discountPercent: deal.discountPercent,
      interestRate: deal.interestRate,
      isMrrIncluded: deal.isMrrIncluded,
      isArrIncluded: deal.isArrIncluded,
      isCashOnHandIncluded: deal.isCashOnHandIncluded,
      isCurrent: deal.isCurrent,
      filesToInclude: deal.filesToInclude,
      isActive: deal.isActive,
      isPublic: deal.isPublic,
    });
  } catch (error) {
    displayError({
      message: 'Failed to load deal data. Please refresh the page.',
      title: 'Loading Error',
    });
  } finally {
    $view.update({
      isLoading: false,
      isTableLoading: false,
    });
  }
}
